module.exports = __webpack_public_path__ + "media/images/icon__unlocked@3x-bb3f7eeb3fc95c2b6e95fbc755ef8bcd.png";